import {
  LEO_KNOWLEDGE_MENU_IDS,
  LEO_SIDEBAR_FOLDER_IDS,
  SYSTEM_SETTINGS_PLATFORM_MENU_IDS
} from '@/constants/sidebarMenuIdSsot'

/** patch 035 曾挂「系统设置」、侧栏已迁至 Leo 知识库「运维工作台」的 menuId */
export const LEO_OPS_MENU_IDS_UNDER_SYSTEM = new Set([
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsBundleCandidates,
  LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
  LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
  LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard,
  LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
  LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
  LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
  LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
  LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
  LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
  LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception
])

export const LEO_OPS_EN_NAMES_UNDER_SYSTEM = new Set([
  'leoDeviceOpsRolePolicy',
  'leoDeviceOpsSemanticTraining',
  'leoDeviceOpsBundleCandidates',
  'leoKnowledgePortalOpsInventory',
  'leoKnowledgePortalOpsDailyHub',
  'leoDeviceOpsReviewInbox',
  'leoDeviceOpsDescriptionAutogen',
  'leoDeviceOpsBLineDailyHub',
  'leoCommandOnboardingWizard',
  'leoXeeGrowthDashboard',
  'leoProductionE2eTraining',
  'leoTurnRoutingTrainingHub',
  'leoTrainingDashboard',
  'leoT2GoldenTraining',
  'leoT9DeepseekTraining',
  'leoTasteHabitPerception'
])

const SYSTEM_SETTING_EN = new Set(['systemSetting', 'systemSettings'])
const SYSTEM_SETTING_NAMES = new Set(['系统设置', '系統設定', '帐号设置', '帳號設置', '账号设置'])

export function isSystemSettingMenuNode (n) {
  if (!n) return false
  const en = n.enName != null ? String(n.enName).trim() : ''
  if (en && SYSTEM_SETTING_EN.has(en)) return true
  const name = n.name != null ? String(n.name).trim() : ''
  return name && SYSTEM_SETTING_NAMES.has(name)
}

export function findSystemSettingMenuId (flat) {
  if (!Array.isArray(flat)) return null
  const hit = flat.find((m) => m && isSystemSettingMenuNode(m))
  return hit && hit.id != null ? String(hit.id) : null
}

function isLeoOpsMenuRecord (m) {
  if (!m || m.id == null) return false
  if (LEO_OPS_MENU_IDS_UNDER_SYSTEM.has(Number(m.id))) return true
  const en = m.enName != null ? String(m.enName).trim() : ''
  return en && LEO_OPS_EN_NAMES_UNDER_SYSTEM.has(en)
}

/**
 * 角色授权树：将误挂 systemSetting 的 Leo 运维叶迁至 Leo 组（优先 990284 运维工作台目录）。
 * 与侧栏 stripLeoOpsFromSystemSettingsSidebar + Leo 知识库树一致。
 */
export function reparentLeoOpsOutOfSystemSettings (flatList) {
  if (!Array.isArray(flatList) || !flatList.length) return flatList
  const systemId = findSystemSettingMenuId(flatList)
  if (!systemId) return flatList

  const hasOpsFolder = flatList.some(
    (m) => m && String(m.id) === String(LEO_SIDEBAR_FOLDER_IDS.opsWorkbench)
  )
  const targetParent = hasOpsFolder
    ? String(LEO_SIDEBAR_FOLDER_IDS.opsWorkbench)
    : String(LEO_KNOWLEDGE_MENU_IDS.group)

  flatList.forEach((m) => {
    if (!isLeoOpsMenuRecord(m)) return
    if (String(m.parentId) !== systemId) return
    m.parentId = targetParent
  })
  return flatList
}

/** 侧栏骨架：从 systemSetting.menuList 剔除 Leo 运维叶（DB 未跑 patch 时的兜底） */
export function stripLeoOpsFromSystemSettingsTree (list) {
  if (!Array.isArray(list)) return
  const sys = list.find((x) => isSystemSettingMenuNode(x))
  if (!sys || !Array.isArray(sys.menuList)) return
  sys.menuList = sys.menuList.filter((x) => {
    if (!x || x.id == null) return false
    if (LEO_OPS_MENU_IDS_UNDER_SYSTEM.has(Number(x.id))) return false
    const en = x.enName != null ? String(x.enName).trim() : ''
    if (en && LEO_OPS_EN_NAMES_UNDER_SYSTEM.has(en)) return false
    return true
  })
}

/** 系统设置平台页须在授权树可见（与侧栏 SYSTEM_SETTINGS_PLATFORM_MENU_IDS 一致） */
export const SYSTEM_SETTINGS_PLATFORM_MENU_ID_SET = new Set(
  Object.values(SYSTEM_SETTINGS_PLATFORM_MENU_IDS).map(Number)
)



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/leoSystemSettingsMenuAlign.js